module.exports = __webpack_public_path__ + "static/img/rightDownTwo.0fc1b07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/matrixImg/rightDownTwo.png
// module id = 4Y/g
// module chunks = 0